import { Icon } from '@tempots/beatui'
import { attr, html, TNode } from '@tempots/dom'
import { Anchor } from '@tempots/ui'
import { Logo } from '@/components/ui'

export interface ContentLayoutOptions {
  backHref?: string
  backText?: string
}

export function ContentLayout(
  options: ContentLayoutOptions,
  ...children: TNode[]
) {
  const { backHref = '/', backText = 'Home' } = options

  return html.div(
    attr.class(
      'h-screen bg-gray-50 flex flex-col gap-4 sm:gap-8 overflow-hidden'
    ),
    // Header
    html.header(
      attr.class('bg-white border-b border-gray-200'),
      html.div(
        attr.class(
          'max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between'
        ),
        Logo({ displaySlogan: false }),
        Anchor(
          { href: backHref },
          attr.class(
            'inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900'
          ),
          Icon({ icon: 'mdi:arrow-left' }, attr.class('w-4 h-4')),
          backText
        )
      )
    ),
    // Content
    html.main(
      attr.class(
        'max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex-grow overflow-hidden'
      ),
      html.article(
        attr.class(
          'bg-white rounded-lg shadow-sm border border-gray-200 p-6 sm:p-8 lg:p-10 h-full overflow-auto'
        ),
        ...children
      )
    ),
    // Footer
    html.footer(
      attr.class('border-t border-gray-200 bg-white'),
      html.div(
        attr.class(
          'max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center text-sm text-gray-500'
        ),
        html.p('© 2025 Verts. All rights reserved.')
      )
    )
  )
}
